<button title={name+' '+language.showHelp} class="relative help inline-flex items-center cursor-default hover:text-primary" style="vertical-align: -2px;" onclick={() => {
    alertMd(language.help[key])
}}>
    
    {#if key === "experimental"}
        <div class="text-red-500 hover:text-primary">
            <FlaskConicalIcon size={16} />
        </div>
    {:else if unrecommended}
        <div class="text-red-500 hover:text-primary">
            <TriangleAlert size={14} />
        </div>
    {:else}
        <CircleQuestionMarkIcon size={14} />
    {/if}    
</button>
<script lang="ts">
    import { TriangleAlert, FlaskConicalIcon, CircleQuestionMarkIcon } from "@lucide/svelte";
    import { language } from "src/lang";
    import { alertMd } from "src/ts/alert";

    interface Props {
        unrecommended?: boolean;
        key: (keyof (typeof language.help));
        name?: string;
    }

    let { unrecommended = false, key, name = '' }: Props = $props();
</script>